import React from "react";

const Contact = () => {
    return (
        <div
            name="contact"
            className="w-full h-screen bg-gradient-to-b from-black to-gray-800 p-4 text-white"
        >
            <div className="flex flex-col p-4 mt-6 justify-center max-w-screen-lg mx-auto h-full">
                <div className="pb-4">
                    <p className="text-4xl font-bold py-2">Contact</p>
                    <p>Fill out the form below to get in touch.</p>
                </div>

                <div className=" flex justify-center items-center">
                    <form
                        action="https://getform.io/f/azylqrkb"
                        method="POST"
                        className=" flex flex-col w-full md:w-1/2"
                    >
                        <input
                            type="text"
                            name="name"
                            placeholder="Enter your name"
                            className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
                        />
                        <input
                            type="text"
                            name="email"
                            placeholder="Enter your email"
                            className="my-4 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
                        />
                        <textarea
                            name="message"
                            placeholder="Enter your message"
                            rows="8"
                            className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
                        ></textarea>

                        <button className="text-white bg-gradient-to-r from-cyan-900 to-rose-600 cursor-pointer px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300">
                            Send
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;